/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container[_ngcontent-%COMP%]   .w-link-btn[_ngcontent-%COMP%]{margin:5px 0}.container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{text-align:center;max-width:150px;font-size:16px}"];
export { styles as styles };
